import { Preloader } from 'mmfintech-portal-commons'

export const CustomPreloader = () => <Preloader />
